var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRefreshlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.75,
    height: 19.869,
    viewBox: "0 0 16.75 19.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_refreshlist",
    d: "M5.625,15.75,9,13.5v.991A5.606,5.606,0,0,0,11.033,4.349L13,3.036A7.857,7.857,0,0,1,9,16.784V18ZM0,9A7.875,7.875,0,0,1,6.75,1.221V0l3.375,2.25L6.75,4.5V3.542A5.582,5.582,0,0,0,4.717,13.651l-1.97,1.313A7.855,7.855,0,0,1,0,9Zm4.447,3.287V10.609h6.82v1.679Zm0-2.465V8.143h6.82V9.822Zm0-2.465V5.678h6.82V7.356Z",
    transform: "translate(0.5 0.934)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshlist);
export default __webpack_public_path__ + "static/media/icon_refreshlist.ebcc3dc06769568578e186b6bc74af7c.svg";
export { ForwardRef as ReactComponent };